import React from 'react';
import { useAuth0 } from '../../context/auth0';
import { useStoreLead } from '../../hooks/useStoreLead';
import pages from '../../define/pages';

const UserTracker = ({
    wait = 25000,
}) => {
    const auth = useAuth0();
    const location = window.location.pathname;

    const getSource = () => {
        switch (true) {
            case location.includes('/attivita/') || location.includes('/en/activity/'): return 'listing';
            case location.includes(pages.checkout): return 'checkout';
            default: return null;
        }
    }

    const source = getSource();

    const listingProcedure = () => {
        const listing_id = document.querySelector('meta[property="product:retailer_item_id"]').content;
        return {
            listing_id: listing_id
        }
    }

    const checkoutProcedure = async () => {
        const data = await fetch('/wp-json/freedome/v1/cart').then(data => data.json())
        const cart = data;

        return {
            availability_id: cart.availability_id,
            listing_id: cart.listing_id,
            product_id: cart.product_idx,
            //currently checkout falls under abandoned carts
            source: 'cart'
        }
    }

    const registerLead = (token, user, lead) => { useStoreLead(token, user.id, lead); }

    const buildLead = async () => {
        if (!auth || !auth.user) return;
        const user = auth.user;

        const newLead = user && {
            id: null,
            user_id: user.id,
            language_code: window.freedomeConfig.locale,
            availability_id: null,
            category_id: null,
            search_term_id: null,
            listing_id: null,
            product_id: null,
            seo_page_id: null,
            status: 'pending',
            source: source,
            data: {}
        }

        switch (source) {
            case 'listing': registerLead(auth.token, user, { ...newLead, ...listingProcedure() }); break;
            case 'checkout': registerLead(auth.token, user, { ...newLead, ...await checkoutProcedure() }); break;
        }
    }

    const timeout = source == 'checkout' ? 10000 : wait;
    setTimeout(buildLead, timeout);

    return <div id='user-tracker'></div>;
};

export default UserTracker;
export { UserTracker };